import { BaseViewModel } from "../../../common/BaseViewModel";
import * as Format from "../../../common/FormatFunctions";
import { CloudService } from "../../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../../common/CloudService/ApiService";
import { CrudlStatus } from "../../../common/config/AppConstants";
import * as UIMap from "../../../common/PrimeComponents";
import * as Storage from "../../../common/config/Storage";
export class CCSelectorViewModel extends BaseViewModel {
  constructor() {
    super();
  }

  getCatalogues = async () => {
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (Format.isNotNull(catalogueResponse.catalogueList)) {
      this.updateState("catalogueList", catalogueResponse.catalogueList);
      var catalgoueArray = UIMap.getDropdownOptions(
        catalogueResponse.catalogueList
      );
      this.updateState("catalogueOptions", catalgoueArray);
      this.logger.info(catalogueResponse.catalogueList);
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      this.updateState("categoryList", categoryResponse.categoryList);
      this.logger.info(categoryResponse.categoryList);
      var categoryArray = UIMap.getDropdownOptions(
        categoryResponse.categoryList
      );
      this.updateState("categoryOptions", categoryArray);
    } else {
      this.showError("Category", CrudlStatus.LIST);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/legacy/CCSelectorViewModel.js